import * as React from "react";

import { IconSvgProps } from "@/types";

export const Logo: React.FC<IconSvgProps> = ({
  width = 200,
  height = 40,
  customClass,
}) => (
  <div className={customClass}>
    <img
      alt="Zanbio Logo"
      className="h-full mx-auto"
      height={height}
      src="/zanbio-logo-circle.svg"
      width={width}
    />
  </div>
);

export const ArrowRight: React.FC<IconSvgProps> = (props) => (
  <svg
    height="1em"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      color="currentColor"
      d="M9 6s6 4.419 6 6s-6 6-6 6"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);

export const NextUILogo: React.FC<IconSvgProps> = (props) => {
  const { width, height = 40 } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 161 32"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className="fill-black dark:fill-white"
        d="M55.6827 5V26.6275H53.7794L41.1235 8.51665H40.9563V26.6275H39V5H40.89L53.5911 23.1323H53.7555V5H55.6827ZM67.4831 26.9663C66.1109 27.0019 64.7581 26.6329 63.5903 25.9044C62.4852 25.185 61.6054 24.1633 61.0537 22.9582C60.4354 21.5961 60.1298 20.1106 60.1598 18.6126C60.132 17.1113 60.4375 15.6228 61.0537 14.2563C61.5954 13.0511 62.4525 12.0179 63.5326 11.268C64.6166 10.5379 65.8958 10.16 67.1986 10.1852C68.0611 10.1837 68.9162 10.3468 69.7187 10.666C70.5398 10.9946 71.2829 11.4948 71.8992 12.1337C72.5764 12.8435 73.0985 13.6889 73.4318 14.6152C73.8311 15.7483 74.0226 16.9455 73.9968 18.1479V19.0773H63.2262V17.4194H72.0935C72.1083 16.4456 71.8952 15.4821 71.4714 14.6072C71.083 13.803 70.4874 13.1191 69.7472 12.6272C68.9887 12.1348 68.1022 11.8812 67.2006 11.8987C66.2411 11.8807 65.3005 12.1689 64.5128 12.7223C63.7332 13.2783 63.1083 14.0275 62.6984 14.8978C62.2582 15.8199 62.0314 16.831 62.0352 17.8546V18.8476C62.009 20.0078 62.2354 21.1595 62.6984 22.2217C63.1005 23.1349 63.7564 23.9108 64.5864 24.4554C65.4554 24.9973 66.4621 25.2717 67.4831 25.2448C68.1676 25.2588 68.848 25.1368 69.4859 24.8859C70.0301 24.6666 70.5242 24.3376 70.9382 23.919C71.3183 23.5345 71.6217 23.0799 71.8322 22.5799L73.5995 23.1604C73.3388 23.8697 72.9304 24.5143 72.4019 25.0506C71.8132 25.6529 71.1086 26.1269 70.3314 26.4434C69.4258 26.8068 68.4575 26.9846 67.4831 26.9663V26.9663ZM78.8233 10.4075L82.9655 17.325L87.1076 10.4075H89.2683L84.1008 18.5175L89.2683 26.6275H87.103L82.9608 19.9317L78.8193 26.6275H76.6647L81.7711 18.5169L76.6647 10.4062L78.8233 10.4075ZM99.5142 10.4075V12.0447H91.8413V10.4075H99.5142ZM94.2427 6.52397H96.1148V22.3931C96.086 22.9446 96.2051 23.4938 96.4597 23.9827C96.6652 24.344 96.9805 24.629 97.3589 24.7955C97.7328 24.9548 98.1349 25.0357 98.5407 25.0332C98.7508 25.0359 98.9607 25.02 99.168 24.9857C99.3422 24.954 99.4956 24.9205 99.6283 24.8853L100.026 26.5853C99.8062 26.6672 99.5805 26.7327 99.3511 26.7815C99.0274 26.847 98.6977 26.8771 98.3676 26.8712C97.6854 26.871 97.0119 26.7156 96.3973 26.4166C95.7683 26.1156 95.2317 25.6485 94.8442 25.0647C94.4214 24.4018 94.2097 23.6242 94.2374 22.8363L94.2427 6.52397ZM118.398 5H120.354V19.3204C120.376 20.7052 120.022 22.0697 119.328 23.2649C118.644 24.4235 117.658 25.3698 116.477 26.0001C115.168 26.6879 113.708 27.0311 112.232 26.9978C110.759 27.029 109.302 26.6835 107.996 25.9934C106.815 25.362 105.827 24.4161 105.141 23.2582C104.447 22.0651 104.092 20.7022 104.115 19.319V5H106.08V19.1831C106.061 20.2559 106.324 21.3147 106.843 22.2511C107.349 23.1459 108.094 23.8795 108.992 24.3683C109.993 24.9011 111.111 25.1664 112.242 25.139C113.373 25.1656 114.493 24.9003 115.495 24.3683C116.395 23.8815 117.14 23.1475 117.644 22.2511C118.16 21.3136 118.421 20.2553 118.402 19.1831L118.398 5ZM128 5V26.6275H126.041V5H128Z"
      />
      <path
        className="fill-black dark:fill-white"
        d="M23.5294 0H8.47059C3.79241 0 0 3.79241 0 8.47059V23.5294C0 28.2076 3.79241 32 8.47059 32H23.5294C28.2076 32 32 28.2076 32 23.5294V8.47059C32 3.79241 28.2076 0 23.5294 0Z"
      />
      <path
        className="fill-white dark:fill-black"
        d="M17.5667 9.21729H18.8111V18.2403C18.8255 19.1128 18.6 19.9726 18.159 20.7256C17.7241 21.4555 17.0968 22.0518 16.3458 22.4491C15.5717 22.8683 14.6722 23.0779 13.6473 23.0779C12.627 23.0779 11.7286 22.8672 10.9521 22.4457C10.2007 22.0478 9.5727 21.4518 9.13602 20.7223C8.6948 19.9705 8.4692 19.1118 8.48396 18.2403V9.21729H9.72854V18.1538C9.71656 18.8298 9.88417 19.4968 10.2143 20.0868C10.5362 20.6506 11.0099 21.1129 11.5814 21.421C12.1689 21.7448 12.8576 21.9067 13.6475 21.9067C14.4374 21.9067 15.1272 21.7448 15.7169 21.421C16.2895 21.1142 16.7635 20.6516 17.0844 20.0868C17.4124 19.4961 17.5788 18.8293 17.5667 18.1538V9.21729ZM23.6753 9.21729V22.845H22.4309V9.21729H23.6753Z"
      />
    </svg>
  );
};

export const LinkAlt: React.FC<IconSvgProps> = (props) => {
  const { width, height = 24 } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.22172 19.7777C4.68559 20.2423 5.23669 20.6106 5.84334 20.8615C6.44999 21.1123 7.10023 21.2409 7.75672 21.2397C8.41335 21.2409 9.06374 21.1123 9.67054 20.8614C10.2774 20.6105 10.8286 20.2422 11.2927 19.7777L14.1207 16.9487L12.7067 15.5347L9.87872 18.3637C9.31519 18.9247 8.55239 19.2397 7.75722 19.2397C6.96205 19.2397 6.19925 18.9247 5.63572 18.3637C5.07422 17.8004 4.75892 17.0375 4.75892 16.2422C4.75892 15.4469 5.07422 14.684 5.63572 14.1207L8.46472 11.2927L7.05072 9.87872L4.22172 12.7067C3.28552 13.6452 2.75977 14.9166 2.75977 16.2422C2.75977 17.5678 3.28552 18.8393 4.22172 19.7777ZM19.7777 11.2927C20.7134 10.354 21.2388 9.08264 21.2388 7.75722C21.2388 6.4318 20.7134 5.16043 19.7777 4.22172C18.8393 3.28552 17.5678 2.75977 16.2422 2.75977C14.9166 2.75977 13.6452 3.28552 12.7067 4.22172L9.87872 7.05072L11.2927 8.46472L14.1207 5.63572C14.6842 5.07471 15.447 4.75975 16.2422 4.75975C17.0374 4.75975 17.8002 5.07471 18.3637 5.63572C18.9252 6.19899 19.2405 6.96189 19.2405 7.75722C19.2405 8.55255 18.9252 9.31545 18.3637 9.87872L15.5347 12.7067L16.9487 14.1207L19.7777 11.2927Z"
        fill="black"
      />
      <path
        d="M8.46371 16.9498L7.04871 15.5358L15.5357 7.0498L16.9497 8.4648L8.46371 16.9498Z"
        fill="black"
      />
    </svg>
  );
};

export const LinkedIn: React.FC<IconSvgProps> = (props) => {
  const { width, height = 24 } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.5244 2.00008H3.4754C3.08857 1.99614 2.71597 2.14582 2.43937 2.41627C2.16277 2.68673 2.00476 3.05587 2 3.44269V20.5606C2.00562 20.9468 2.16401 21.3151 2.44052 21.5849C2.71702 21.8546 3.08913 22.0039 3.4754 21.9999H20.5244C20.9113 22.003 21.2836 21.8528 21.5601 21.5822C21.8366 21.3116 21.9947 20.9425 21.9998 20.5557V3.43777C21.9929 3.05208 21.8341 2.6847 21.5578 2.41549C21.2816 2.14628 20.9102 1.99699 20.5244 2.00008Z"
        fill="#0076B2"
      />
      <path
        d="M4.96067 9.49674H7.9295V19.0491H4.96067V9.49674ZM6.44591 4.74268C6.78642 4.74268 7.11928 4.84367 7.40238 5.03288C7.68548 5.22209 7.9061 5.49102 8.03634 5.80564C8.16657 6.12026 8.20056 6.46644 8.13401 6.80039C8.06746 7.13433 7.90336 7.44103 7.66247 7.6817C7.42158 7.92236 7.11472 8.08617 6.78071 8.1524C6.4467 8.21863 6.10056 8.18431 5.78606 8.05378C5.47156 7.92324 5.20285 7.70236 5.0139 7.41908C4.82496 7.1358 4.72429 6.80285 4.72461 6.46233C4.72504 6.0061 4.90659 5.5687 5.22935 5.24625C5.5521 4.9238 5.98968 4.74268 6.44591 4.74268ZM9.79178 9.49674H12.6377V10.8082H12.677C13.0737 10.0574 14.0409 9.26559 15.4852 9.26559C18.4917 9.25903 19.0491 11.2377 19.0491 13.8033V19.0491H16.0803V14.4016C16.0803 13.2951 16.0606 11.8705 14.5377 11.8705C13.0147 11.8705 12.7557 13.077 12.7557 14.3295V19.0491H9.79178V9.49674Z"
        fill="white"
      />
    </svg>
  );
};

export const Facebook: React.FC<IconSvgProps> = (props) => {
  const { width, height = 24 } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 12C22 6.47719 17.5228 2 12 2C6.47719 2 2 6.47719 2 12C2 16.9913 5.65687 21.1284 10.4375 21.8785V14.8906H7.89844V12H10.4375V9.79688C10.4375 7.29063 11.9305 5.90625 14.2147 5.90625C15.3088 5.90625 16.4531 6.10156 16.4531 6.10156V8.5625H15.1922C13.9499 8.5625 13.5625 9.33336 13.5625 10.1242V12H16.3359L15.8926 14.8906H13.5625V21.8785C18.3431 21.1284 22 16.9913 22 12Z"
        fill="#1877F2"
      />
      <path
        d="M15.8926 14.8906L16.3359 12H13.5625V10.1242C13.5625 9.33328 13.9499 8.5625 15.1922 8.5625H16.4531V6.10156C16.4531 6.10156 15.3088 5.90625 14.2146 5.90625C11.9305 5.90625 10.4375 7.29063 10.4375 9.79688V12H7.89844V14.8906H10.4375V21.8785C10.9544 21.9595 11.4768 22.0001 12 22C12.5232 22.0001 13.0456 21.9595 13.5625 21.8785V14.8906H15.8926Z"
        fill="white"
      />
    </svg>
  );
};

export const X: React.FC<IconSvgProps> = (props) => {
  const { width, height = 24 } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.1761 4.24268H19.9362L13.9061 11.0201L21 20.2427H15.4456L11.0951 14.6493L6.11723 20.2427H3.35544L9.80517 12.9935L3 4.24268H8.69545L12.6279 9.3553L17.1761 4.24268ZM16.2073 18.6181H17.7368L7.86441 5.78196H6.2232L16.2073 18.6181Z"
        fill="black"
      />
    </svg>
  );
};

export const ChevronRight: React.FC<IconSvgProps> = (props) => {
  const { width, height = 16 } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 16 16"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.47147 11.2998L10.2761 7.4951L6.47147 3.69043L5.52881 4.6331L8.39081 7.4951L5.52881 10.3571L6.47147 11.2998Z"
        fill="black"
      />
    </svg>
  );
};
